import { forwardRef } from 'react';
import mergeProps from 'merge-props';
import { Button } from '.';
const LinkButton = forwardRef((props, ref) => {
    const { className, children, disabled, kind, fullWidth, iconLeft, iconRight, size, type, renderAs, ...restProps } = props;
    const renderAsLink = (btnProps) => {
        if (type === 'submit') {
            throw new Error('The type property can not have a submit value when used with the LinkButton component.');
        }
        return (
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        <a {...mergeProps(btnProps, {
            className,
            'aria-disabled': disabled,
            ref
        }, restProps)}/>);
    };
    return (<Button kind={kind} fullWidth={fullWidth} size={size} iconLeft={iconLeft} iconRight={iconRight} renderAs={renderAs || renderAsLink}>
      {children}
    </Button>);
});
LinkButton.displayName = 'LinkButton';
export { LinkButton };
//# sourceMappingURL=LinkButton.jsx.map